import React from 'react'
import './section8.css'
import Repeatedsection from '../Repeatedsection/Repeatedsection'
const Section8 = () => {
  return (
    <>
      <Repeatedsection title='Mens Fashion'/>
    </>
  )
}

export default Section8
